__turbopack_context__.v({
  "clickableChip": "NqOQSW_clickableChip",
});
